import type {FC} from 'react'
import {useParams} from 'react-router-dom'
import templatesData from '../../../data/sales/salesTemplatesData'
import BulkRun from '../../universal-components/bulk-run/BulkRun'
import {useTranslation} from 'react-i18next'

interface SalesBulkRunPageProps {}

const SalesBulkRunPage: FC<SalesBulkRunPageProps> = () => {
  const {templateUrl} = useParams()
  const {t} = useTranslation()
  const templateItem: any = templatesData.templates.find((item: any) =>
    item.url.includes(templateUrl)
  )
  const title = t(`workflows.sales.${templateItem.lang_key}.title`)

  return <BulkRun title={title} templateItem={templateItem} />
}

export default SalesBulkRunPage
